export const OrderStatusText = {
  Paused: 'Paused',
  Waiting: 'Waiting',
  Staged: 'Staged',
  Filled: 'Filled',
  FilledAndCanceled: 'Filled & Canceled',
  Canceled: 'Canceled',
  PendingCancel: 'Pending Cancel',
  PendingReplace: 'Pending Replace',
  Rejected: 'Rejected',
  Open: 'Open',
  SystemPaused: 'System Paused',
  PendingFix: 'Filled - Pending Fix',
  Unknown: 'Unknown',
} as const;
export type OrderStatusText = (typeof OrderStatusText)[keyof typeof OrderStatusText];

export const OrderStatusSize = {
  Small: 0,
  Default: 1,
} as const;
export type OrderStatusSize = (typeof OrderStatusSize)[keyof typeof OrderStatusSize];

export const QuoteStatusText = {
  Filled: 'Filled',
  Canceled: 'Canceled',
  PendingNew: 'Pending New',
  PendingCancel: 'Pending Cancel',
  Rejected: 'Rejected',
  Open: 'Open',
  PendingFix: 'Filled - Pending Fix',
} as const;
export type QuoteStatusText = (typeof QuoteStatusText)[keyof typeof QuoteStatusText];
